import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import cx from 'classnames';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import withThemeProps from '../../../theme/withThemeProps';
var useStyles = makeStyles(function (theme) {
  return {
    silentRoot: {
      transition: theme.transitions.create('all'),
      backgroundColor: 'transparent',
      border: 'none',
      paddingLeft: 0,
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        paddingLeft: 12,
        border: 'none'
      },
      '&:focus-within': {
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        paddingLeft: 12
      }
    }
  };
}, {
  name: 'ECTextFormInput'
});
/**
 * @param {import('../types').FormInputTextProps} props
 */

var TextFormInput = function TextFormInput(_ref) {
  var selectOnFocus = _ref.selectOnFocus,
      silent = _ref.silent,
      onEnter = _ref.onEnter,
      onEscape = _ref.onEscape,
      rest = _objectWithoutProperties(_ref, ["selectOnFocus", "silent", "onEnter", "onEscape"]);

  var classes = useStyles({});

  var inputProps = _objectSpread({}, rest.inputProps);

  if (inputProps.onFocus) {
    var base = inputProps.onFocus;

    inputProps.onFocus = function (e) {
      if (selectOnFocus) {
        if (typeof selectOnFocus === 'function') {
          var pos = selectOnFocus(e.target.value);
          e.target.setSelectionRange(pos[0], pos[1]);
        } else {
          //all
          e.target.setSelectionRange(0, e.target.value.length);
        }
      }

      return base(e);
    };
  }

  if (onEnter) {
    inputProps.onKeyPress = function (e) {
      if (e.key === 'Enter') if (onEnter) onEnter(e);
    };
  }

  if (onEscape) {
    inputProps.onKeyUp = function (e) {
      if (e.key === 'Escape') if (onEscape) onEscape(e);
    };
  }

  return React.createElement(TextField, Object.assign({
    InputProps: {
      classes: {
        root: cx(_defineProperty({}, classes.silentRoot, silent))
      }
    },
    fullWidth: true
  }, rest, {
    inputProps: inputProps
  }));
};

TextFormInput.defaultProps = {
  selectOnFocus: false,
  silent: false
};
/** @type {React.FC<import('../types').FormInputTextProps>} */

var TextFormInputExport = withThemeProps('Form.Input.Text')(TextFormInput);
export default TextFormInputExport;